<div class="container">

  <app-header-dialog [iconName]="'home'">
    Sala/Auditório
  </app-header-dialog>

  <div class='content'>

    <form name="roomForm" [formGroup]='roomForm' autocomplete="off">

      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Nome</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="roomForm.controls.name"
          autocomplete="off">
        <mat-error *ngIf="roomForm.controls.name.hasError('required')">
          O Nome é obrigatório
        </mat-error>
      </mat-form-field>

    </form>

  </div>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>

    <button [disabled]='roomForm.invalid' mat-raised-button (click)="matDialogRef.close([ 'add', roomForm ])"
      *ngIf="!isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

    <button [disabled]='roomForm.invalid' mat-raised-button (click)="matDialogRef.close([ 'edit', roomForm ])"
      *ngIf="isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

  </div>

</div>